import React, { FunctionComponent } from 'react';

import { MotorFullPageProps } from 'scenes/motor/types';
import { getVehicleFinancier } from 'scenes/motor/selectors';
import { getApiData } from 'scenes/common/helpers/apiData';
import SingleSelectStep from 'scenes/common/components/Steps/SingleSelectStep';

const VEHICLE_FINANCIER = 'vehicleFinancier';
export const QUESTION = 'Who financed the car?';

const VehicleFinancierStep: FunctionComponent<MotorFullPageProps> = ({
  referenceData,
  funnelState,
  onNext,
}) => {
  const { financialInstitutions } = getApiData(referenceData);

  return (
    <SingleSelectStep
      options={financialInstitutions}
      stateKey={VEHICLE_FINANCIER}
      question={QUESTION}
      defaultStateValue={getVehicleFinancier(funnelState)}
      onNext={onNext}
    />
  );
};

export default VehicleFinancierStep;
